import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ReminderRunner from "./components/ReminderRunner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import GetApp from "./pages/GetApp";
import Dashboard from "./pages/Dashboard";
import Checkin from "./pages/Checkin";
import SafetyPlan from "./pages/SafetyPlan";
import Assistant from "./pages/Assistant";
import Contacts from "./pages/Contacts";
import MoodDiary from "./pages/MoodDiary";
import SafetyVault from "./pages/SafetyVault";
import Toolkit from "./pages/Toolkit";
import SettingsPage from "./pages/Settings";
import Share from "./pages/Share";
import SharedView from "./pages/SharedView";
import PlanExport from "./pages/PlanExport";
import Reminders from "./pages/Reminders";
import Billing from "./pages/Billing";
import Wrap from "./pages/Wrap";
import TrustAdmin from "./pages/TrustAdmin";
import AdminPanel from "./pages/AdminPanel";
import DpaSign from "./pages/DpaSign";
import NhsConnect from "./pages/NhsConnect";
import ForNhs from "./pages/ForNhs";
import { Toaster } from "./components/ui/sonner";

const Protected = ({ children }) => (
  <ProtectedRoute>
    <ReminderRunner />
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/v/:token" element={<SharedView />} />
          <Route path="/for-nhs" element={<ForNhs />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/checkin" element={<Protected><Checkin /></Protected>} />
          <Route path="/plan" element={<Protected><SafetyPlan /></Protected>} />
          <Route path="/wrap" element={<Protected><Wrap /></Protected>} />
          <Route path="/export" element={<Protected><PlanExport /></Protected>} />
          <Route path="/share" element={<Protected><Share /></Protected>} />
          <Route path="/reminders" element={<Protected><Reminders /></Protected>} />
          <Route path="/billing" element={<Protected><Billing /></Protected>} />
          <Route path="/trust" element={<Protected><TrustAdmin /></Protected>} />
          <Route path="/dpa" element={<Protected><DpaSign /></Protected>} />
          <Route path="/nhs" element={<Protected><NhsConnect /></Protected>} />
          <Route path="/admin" element={<Protected><AdminPanel /></Protected>} />
          <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
          <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
          <Route path="/mood" element={<Protected><MoodDiary /></Protected>} />
          <Route path="/vault" element={<Protected><SafetyVault /></Protected>} />
          <Route path="/toolkit" element={<Protected><Toolkit /></Protected>} />
          <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
          <Route path="/get-app" element={<Protected><GetApp /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
